import { Injectable } from '@angular/core';

export interface IAuthenticationConfig {
  connection?: string;
  identityToken: {
    header: string;
    allowedList?: string[] | undefined;
  };
}

@Injectable()
export class AuthenticationConfig implements IAuthenticationConfig {
  connection!: IAuthenticationConfig['connection'];
  identityToken!: IAuthenticationConfig['identityToken'];
}
